import PageHeader from "../theme/components/common/PageHeader";
import * as React from "react";
import Table from "react-bootstrap/Table";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import apiClient from "../api";
import { gettext } from "../i18n";
import DefaultTooltip from "components/common/DefaultTooltip";
import {
  onInputFileChange,
  parseExcelFormat,
  groupDataForAPI,
  getTotalDatapointsCount,
  GroupedStationData,
} from "utils/xlsx";
import "./MeasurementStationDataUploadPage.scss";

const MeasurementStationDataUploadPage = () => {
  const [savingUploadedValues, setSavingUploadedValues] =
    React.useState<boolean>(false);
  const [uploadedValues, setUploadedValues] =
    React.useState<GroupedStationData>({});

  const uploadDatapoints = () => {
    if (
      !uploadedValues ||
      Object.keys(uploadedValues).length === 0 ||
      savingUploadedValues
    ) {
      return;
    }

    setSavingUploadedValues(true);
    const requestPath = "/admin/upload-channel-datapoints";
    apiClient
      .request(requestPath, {
        method: "POST",
        data: {
          groupedDatapoints: uploadedValues,
        },
      })
      .then(() => {
        toast.success(gettext("Success"));
        setUploadedValues({});
        setSavingUploadedValues(false);
      })
      .catch((e) => {
        toast.error(e.message.toString());
        setSavingUploadedValues(false);
      });
  };

  const onFileLoaded = (data: string[][]) => {
    if (!data || data.length === 0) {
      toast.error("No data found in the uploaded file");
      return;
    }

    console.log("Raw file data:", data);

    try {
      const processedData = parseExcelFormat(data);
      console.log("Processed data:", processedData);

      const groupedData = groupDataForAPI(processedData);
      console.log("Grouped data:", groupedData);

      setUploadedValues(groupedData);

      if (Object.keys(groupedData).length > 0) {
        const stationCount = Object.keys(groupedData).length;
        const totalDatapoints = getTotalDatapointsCount(groupedData);

        toast.success(
          `Parsed ${totalDatapoints} datapoints from ${stationCount} station${
            stationCount > 1 ? "s" : ""
          }`
        );
      } else {
        toast.warning(
          "No valid datapoints found in the uploaded file. Please check the format."
        );
      }
    } catch (error) {
      console.error("Error parsing Excel data:", error);
      const errorMessage =
        error instanceof Error ? error.message : "Please check the format.";
      toast.error(`Error parsing file: ${errorMessage}`);
    }
  };

  return (
    <div className="MeasurementStationDataUploadPage">
      <PageHeader
        title={gettext("Import channel data")}
        className="mb-3"
      ></PageHeader>
      <Card className="mb-3">
        <Card.Body>
          {!savingUploadedValues && (
            <>
              <Table responsive>
                <thead>
                  <tr>
                    <th colSpan={4}>
                      <div className="uploadHeader">
                        Upload datapoints from CSV or XLSX file
                        <div className="templateButton">
                          <a href="/xlsx/example_file_for_import.xlsx">
                            <Button>Download Template</Button>
                          </a>
                          <DefaultTooltip
                            popHeader={gettext("Template File")}
                            popBody={
                              <p>
                                Use the Excel template with Station ID (A),
                                Timestamp (B), and multiple channel columns (C+)
                                with units in row 2 and values in rows 3+.
                              </p>
                            }
                          />
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <input
                        type="file"
                        name="file-upload-input"
                        accept=".csv, .xlsx"
                        onChange={onInputFileChange(onFileLoaded)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <Button
                        type="button"
                        variant="primary"
                        disabled={
                          savingUploadedValues ||
                          Object.keys(uploadedValues).length === 0
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          uploadDatapoints();
                        }}
                      >
                        Upload ({getTotalDatapointsCount(uploadedValues)}{" "}
                        datapoints)
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default MeasurementStationDataUploadPage;
